import { reduxForm } from 'redux-form';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { RenderSubmitButton } from '../../../common/form';
import { removeTable, fetchAllTable } from '../../../../actions/SeatingChartActions';

const DeleteTableModal = ({ handleSubmit, pristine, submitting, valid }) => (
  <div>
    <div className="modal-header">
      <h3 className="modal-title">Delete Table</h3>
    </div>
    <form onSubmit={handleSubmit} id="table-form" className="tableModal__form" noValidate>
      <h3>Are You Sure You Want to Delete Table 2?</h3>
      <h4>By deleting this table, all guests currently seated at the table will be returned to the guest list.</h4>
      <div className="buttonGroup">
        <button className="btn btn-primary tableModal__form--delete"> Cancel </button>
        <RenderSubmitButton className="tableModal__form--save" pristine={pristine} submitting={submitting} valid={valid} />
      </div>
    </form>
  </div>
);

DeleteTableModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit: createTaskRequest => dispatch(removeTable(createTaskRequest)).then(() => {
      ownProps.hideModalFn();
      dispatch(fetchAllTable());
    })
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'table_form'
})(DeleteTableModal));



/** WEBPACK FOOTER **
 ** ./src/components/manage/seatingchart/seatingChartModals/DeleteTableModal.jsx
 **/